"use client"

import { useEffect } from "react"

import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (typeof window === "undefined" || process.env.NODE_ENV !== "production") return
    try {
      if (!window.isSecureContext) return
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        defaults: "2025-11-30",
        person_profiles: "always"
      })
    } catch (error) {
      console.warn("[PostHogProvider] init failed:", error)
    }
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
